import { FaIcon } from '@acp/core-ui';
import { IntegratedCompliancePropertyStatus } from '@acp/shared';
import { Text } from '@chakra-ui/react';
import { SizeProp } from '@fortawesome/fontawesome-svg-core';
import { faCheckCircle, faExclamationCircle } from '@fortawesome/pro-regular-svg-icons';
import React from 'react';

function IntegratedPropertyComplianceBadgeRefFunction(
    {
        complianceStatus,
        iconSize = '1x',
        ...props
    }: {
        complianceStatus: IntegratedCompliancePropertyStatus;
        iconSize?: SizeProp;
    } & Omit<React.ComponentProps<typeof Text>, 'ref'>,
    ref: React.ForwardedRef<HTMLParagraphElement>
) {
    if (complianceStatus === IntegratedCompliancePropertyStatus.NonResidentialProperty) {
        return null;
    }

    if (complianceStatus === IntegratedCompliancePropertyStatus.Compliant) {
        return (
            <Text {...props} cursor="default" w="fit-content" ref={ref}>
                <FaIcon
                    icon={faCheckCircle}
                    mr={2}
                    color="success.500"
                    size={iconSize}
                />
                Compliant*
            </Text>
        );
    }

    if (complianceStatus === IntegratedCompliancePropertyStatus.ComplianceIssues) {
        return (
            <Text {...props} cursor="default" w="fit-content" ref={ref}>
                <FaIcon
                    icon={faExclamationCircle}
                    mr={2}
                    color="danger.500"
                    size={iconSize}
                />
                Compliance issues*
            </Text>
        );
    }

    return null;
}

export const IntegratedPropertyComplianceBadge = React.forwardRef(
    IntegratedPropertyComplianceBadgeRefFunction
);
